import {AssetCategory} from '../entities/AssetCategory';
import {LibraryItemType} from '../entities/LibraryItemType'
import { LibraryView } from '../pages/Library/LibraryPage';

export const DisplayTextHelper = {
    fromAssetCategory:(cat: AssetCategory) => {
        let displayText: string = "Sermon Manuscript";

        switch (cat) {
            case AssetCategory.Outline:
                displayText = "Sermon Outline";
                break;
            case AssetCategory.Audio:
                displayText = "Sermon Audio";
                break;
            case AssetCategory.Devotional:
                displayText = "Devotional";
                break;
            case AssetCategory.Handout:
                displayText = "Handout";
                break;
            case AssetCategory.Notes:
                displayText = "Notes";
                break;
            case AssetCategory.SermonSlides:
                displayText = "Presentation Slides";
                break;
            case AssetCategory.SmallGroupStudy:
                displayText = "Small Group Study";
                break;
            case AssetCategory.Video:
                displayText = "Sermon Video";
                break;
            default:
                break;
        }

        return displayText;
    },

    fromLibraryItemType: (type: LibraryItemType) => {
        let displayText: string = "";

        switch (type) {
            case LibraryItemType.Folder:
                displayText = "Folder";
                break;
            case LibraryItemType.SermonSeries:
                displayText = "Series";
                break;
            case LibraryItemType.PremiumSermon:
                displayText = "Premium Sermon";
                break;
            case LibraryItemType.PremiumSermonSeries:
                displayText = "Premium Series";
                break;
            default:
        }

        return displayText;
    },
    
    fromLibraryView: (view: LibraryView) => {
        switch(view){
            case(LibraryView.Recent):
                return "Recent";
            case(LibraryView.Starred):
                return "Starred";
            case(LibraryView.Search):
                return "Search";
            case(LibraryView.Calendar):
                return "Calendar";
            case(LibraryView.OfflineAccess):
                return "OfflineAccess";
            case(LibraryView.PremiumSermonDetail):
                return "Premium Sermon";
            case(LibraryView.PremiumSermonList):
                return "Premium Sermons";
            case(LibraryView.PremiumSermonSeriesDetail):
                return "Premium Series";
            case(LibraryView.PremiumSermonSeriesList):
                return "Premium Sermon Series";
            case(LibraryView.SermonTemplateDetail):
                return "Sermon Templates";
            default:
                return "Library Home"
        }
    }
}